import config from 'config'
import { Main } from 'components/masters'
import { get } from 'lodash'
import React from 'react'
import * as Page from 'containers/pages'
import { Tabs } from 'components/layout'
import { ORGANIZATION_HIERARCHY } from 'constants/enums'
import { Redirect } from 'react-router-dom'

const subRouteStructure = ({ urlPrefix, isTypeId } = {}) => [
    {
        path: `${urlPrefix}`,
        isTypeId: isTypeId,
        component: props => (
            <Page.Organization
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        ),
        routes: [
            {
                path: `${urlPrefix}`,
                exact: true,
                component: () => (
                    <Redirect to={`${urlPrefix}/detail`} />
                )
            },
            {
                path: `${urlPrefix}/detail`,
                exact: true,
                component: props => (
                    <Page.OrganizationDetail {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/registration`,
                exact: true,
                component: props => (
                    <Page.OrganizationRegistration {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/payment`,
                exact: true,
                component: props => (
                    <Page.OrganizationPayments {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/awards`,
                exact: true,
                component: props => (
                    <Page.OrganizationAwards {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/award-units`,
                exact: true,
                component: props => (
                    <Page.OrganizationAwardUnits {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/organizations`,
                exact: true,
                component: props => (
                    <Page.OrganizationAUsIACs {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/sub-global-operating-partners`,
                exact: true,
                component: props => (
                    <Page.OrganizationSubGlobalOperatingPartners {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/operating-authorities`,
                exact: true,
                component: props => (
                    <Page.OrganizationOperatingAuthorities {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/sub-operating-authorities`,
                exact: true,
                component: props => (
                    <Page.OrganizationSubOperatingAuthorities {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/independent-countries`,
                exact: true,
                component: props => (
                    <Page.OrganizationIndependentCountries {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/independent-award-centres`,
                exact: true,
                component: props => (
                    <Page.OrganizationIACs {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/award-leaders`,
                exact: true,
                component: props => (
                    <Page.OrganizationAwardLeaders {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/participants`,
                exact: true,
                component: props => (
                    <Page.OrganizationParticipants {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/payments`,
                exact: true,
                component: props => (
                    <Page.OrganizationPayments {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/logs`,
                exact: true,
                component: props => (
                    <Page.OrganizationHistory {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/customizations`,
                isTypeId: isTypeId,
                exact: true,
                component: props => (
                    <Page.OrganizationCustomization {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/api-keys`,
                exact: true,
                component: props => (
                    <Page.OrganizationApiKeys {...props} params={get(props, 'match.params', {})} />
                )
            },
            {
                path: `${urlPrefix}/profile-questions`,
                exact: true,
                component: props => (
                    <Page.ProfileQuestions {...props} params={get(props, 'match.params', {})} />
                )
            }
        ]
    }
]

const routeStructure = ({ urlPrefix, isTypeId, gridComponent } = {}) => [
    {
        path: `${urlPrefix}`,
        parent: isTypeId,
        component: props => (
            <Main {...props} params={get(props, 'match.params', {})} />
        ),
        routes: [
            {
                path: `${urlPrefix}`,
                exact: true,
                component: gridComponent
            },
            ...subRouteStructure({
                urlPrefix: `${urlPrefix}/:id`,
                isTypeId
            })
        ]
    }
]


const publicPath = config.publicPath
const routes = [

    ...routeStructure({
        urlPrefix: `${publicPath}/sub-operating-authorities`,
        isTypeId: ORGANIZATION_HIERARCHY.SOA.id,
        gridComponent: props => (
            <Page.SubOperatingAuthorities
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    }),

    ...routeStructure({
        urlPrefix: `${publicPath}/operating-authorities`,
        isTypeId: ORGANIZATION_HIERARCHY.OA.id,
        gridComponent: props => (
            <Page.OperatingAuthorities
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    }),

    ...routeStructure({
        urlPrefix: `${publicPath}/global-operating-partners`,
        isTypeId: ORGANIZATION_HIERARCHY.GOP.id,
        gridComponent: props => (
            <Page.GlobalOperatingPartners
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    }),

    ...routeStructure({
        urlPrefix: `${publicPath}/sub-global-operating-partners`,
        isTypeId: ORGANIZATION_HIERARCHY.SGOP.id,
        gridComponent: props => (
            <Page.SubGlobalOperatingPartners
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    }),

    ...routeStructure({
        urlPrefix: `${publicPath}/national-offices`,
        isTypeId: ORGANIZATION_HIERARCHY.NAO.id,
        gridComponent: props => (
            <Page.NationalOffices
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    }),

    ...routeStructure({
        urlPrefix: `${publicPath}/independent-countries`,
        isTypeId: ORGANIZATION_HIERARCHY.IC.id,
        gridComponent: props => (
            <Page.IndependentCountries
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    }),

    ...routeStructure({
        urlPrefix: `${publicPath}/regions`,
        isTypeId: ORGANIZATION_HIERARCHY.RO.id,
        gridComponent: props => (
            <Page.Regions
                {...props}
                params={get(props, 'match.params', {})}
                tabs={
                    <Tabs {...props} params={get(props, 'match.params', {})} />
                }
            />
        )
    })

]

export default routes
